import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'app-o-ring-failure',
    templateUrl: './o-ring-failure.component.html',
    styleUrls: [
        './o-ring-failure.component.scss',
    ],
    standalone: false
})
export class ORingFailureComponent implements OnInit {
  constructor(
    private meta: Meta,
    private title: Title,
  ) {
    this.meta.updateTag({name: "search-title", class: "swiftype", content: "Common O-ring Failures", "data-type": "string"});
    this.title.setTitle(`O-Ring Failure & Troubleshooting Guide | Marco Sealing Solutions`);
  }

  ngOnInit() {
  }

}
